import styled from "styled-components";

export const Section = styled.section`
  padding: 20px;
  display: flex;
  justify-content: center;
`;

export const FormContainer = styled.div`
  background: #f4f4ef;
  color: #04202c;
  padding: 25px;
  border-radius: 12px;
  width: 500px;
  margin: 20px auto;
  font-family: "LXGW WenKai TC", cursive;
  border: 1px solid #5b7065;
`;

export const Title = styled.h1`
  font-family: "LXGW Marker Gothic", sans-serif;
  font-size: 18px;
  color: #04202c;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 500;
  color: #304040;
`;

export const Input = styled.input`
  background: #ffffff;
  border: 1px solid #acbebe;
  padding: 10px;
  border-radius: 6px;
  font-size: 14px;
  font-family: "LXGW WenKai TC", cursive;
  color: #04202c;
  outline: none;

  &:focus {
    border-color: #5b7065;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 15px;
`;

export const ActionButton = styled.button`
  flex: 1;
  padding: 10px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: "LXGW WenKai TC", cursive;
  font-weight: 500;
  font-size: 14px;
  color: white;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.2s ease;

  background-color: ${(props) => {
    if (props.danger) return "#871119ff";
    if (props.clear) return "#506e5eff";
    return "#07691fff";
  }};

  margin-top: ${(props) => (props.mt ? "15px" : "0")};

  &:hover {
    opacity: 0.9;
  }
`;

export const DataBlock = styled.div`
  font-size: 15px;
  margin-top: 30px;
`;

export const SubTitle = styled.h2`
  font-family: "LXGW Marker Gothic", sans-serif;
  font-size: 18px;
  margin-bottom: 10px;
  color: #04202c;
`;

export const UsersWrapper = styled.div`
  margin-top: 30px;

  p {
    font-size: 15px;
  }
`;

export const UserCard = styled.div`
  background-color: #ffffff;
  padding: 12px;
  border-radius: 6px;
  margin-top: 10px;
  border-left: 4px solid #5b7065;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  p {
    margin: 4px 0;
    font-size: 14px;
    color: #04202c;
  }
`;

export const CardButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
`;

const UserCardButton = styled.button`
  padding: 6px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-family: "LXGW WenKai TC", cursive;
  font-size: 13px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  background: transparent;

  &:hover {
    transform: translateY(-2px);
  }
`;

export const EditButton = styled(UserCardButton)`
  color: #07691f;
  border: 1px solid #07691f;
`;

export const DeleteButton = styled(UserCardButton)`
  color: #a01d26;
  border: 1px solid #a01d26;
`;
